module.exports = __webpack_public_path__ + "img/pick_point.e2e13c6.svg";